import React from 'react';
import { Input } from 'reactstrap';

export default function CurrencyInput({ id, ...inputProps }) {
  return <Input id={id} type="number" step="0.01" min="0" {...inputProps} />;
}
